import { Injectable } from '@angular/core';
import { EntityStore } from '@examdojo/state';
import { ImageChatMessageState, ImageChatMessageStoreModel } from '../models';

@Injectable({ providedIn: 'root' })
export class ImageChatMessageStore extends EntityStore<ImageChatMessageState, ImageChatMessageStoreModel, 'id'> {
  constructor() {
    super({
      idKey: 'id',
      name: 'image-chat-message',
      initialPropsState: {
        reviewableItemId: null,
        imageIndexToChatId: {},
      },
    });
  }
}
